module.exports = __webpack_public_path__ + "img/default-extra.4292a18b.png";